import { useMemo } from 'react'
import { LocationDTO } from '@sales-center/common'
import { useGetServicesByLocationId } from '@user/store/locations/hooks/useGetServicesByLocationId'
import {
  locationTypeValueFormatter,
  divisionValueFormatter,
  currencyValueFormatter,
} from '../valueFormaters'
import { notAvailableValue } from '../constants'

export function useGetServiceLocationListPropValue(
  params: LocationDTO,
  fieldName: string,
) {
  const { id, locationTypeId, divisionId } = params
  const services = useGetServicesByLocationId(id.toString())
  const cellValue = useMemo(() => {
    let result: string = ''
    switch (fieldName) {
      case 'initialValue': {
        result = currencyValueFormatter(
          services.reduce((sum, current) => sum + current.initialPrice, 0),
        )
        break
      }
      case 'recurringValue': {
        result = currencyValueFormatter(
          services.reduce((sum, current) => sum + current.totalSubsequent, 0),
        )
        break
      }
      case 'totalValue': {
        result = currencyValueFormatter(
          services.reduce((sum, current) => sum + current.totalFirst, 0),
        )
        break
      }
      case 'divisionId': {
        result = divisionValueFormatter(divisionId)
        break
      }
      case 'locationTypeId': {
        result = locationTypeValueFormatter(locationTypeId)
        break
      }
      default: {
        //statements;
        break
      }
    }
    return result.length > 0 ? result : notAvailableValue
  }, [fieldName, services, locationTypeId, divisionId])

  return {
    cellValue,
  }
}
